exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-select-text-wrap .yxt-select-dropdown__suffix{height:auto;line-height:normal}.yxtbiz-select-text-wrap .error-message{color:red;line-height:18px;font-size:12px}\n", ""]);

